import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import LandingNav from "./Landing_Nav";
import LandingFooter from "./Landing_Footer";
import callgirlimage from "../../images/LandingPageImage/contactuspagehero.webp";
import Chat22 from "../../images/Chat22.svg";
import FAQSection from "./FAQ_Section";
import TickShield from "../../images/TickShield.svg";
import CrossChannel from "../../images/CrossChannel.svg";
import bgcontact from "../../images/LandingPageImage/bgContact.webp";
import signup from "../../images/signup.svg";
import address from "../../images/LandingPageImage/marker-02.svg";
import call from "../../images/LandingPageImage/phone-call-01.svg";
import email from "../../images/LandingPageImage/globe-03.svg";
import Navbar from "../Main_Landing_Page/Navbar";
import Footer from "../Main_Landing_Page/Footer";
import NewFreeTrial from "../Main_Landing_Page/NewFreeTrial";

const Contact = ({ onSignUpClick, onLoginClick, country, handleCountryChange }) => {
  useEffect(() => {
    const currentUrl = window.location.href;
    const encodedUrl = encodeURIComponent(currentUrl);
    const script = document.createElement("script");
    script.src = `https://anlook.com/SeoBix/seo_injection.php?webid=56c53e1ff4273fa3746b406c70f5bf9c&url=${encodedUrl}&baseUrl=https%3A%2F%2Fanlook.com`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
   const [showFreeTrial, setShowFreeTrial] = useState(false);
  
    useEffect(() => {
      const alreadyClosed = sessionStorage.getItem("freeTrialClosed_global");
  
      if (!alreadyClosed) {
        const timer = setTimeout(() => {
          setShowFreeTrial(true);
        }, 1200);
  
        return () => clearTimeout(timer);
      }
    }, []);
  
    const handleCloseModal = () => {
      sessionStorage.setItem("freeTrialClosed_global", "true");
      setShowFreeTrial(false);
    };

  return (
    <>


      <div className="bg-green-removed">
        <Navbar onSignUpClick={onSignUpClick} onLoginClick={onLoginClick} country={country} handleCountryChange={handleCountryChange} />

        <div
          className="row col-12 d-flex justify-content-between  padding-5-rem  py-0"
          // style={{ backgroundColor: "#EDF3FE",color: "#0c4d45"}}
          style={{
            backgroundImage: `url(${bgcontact})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            color: "#0c4d45",
          }}
        >
          <div
            className="col-12 col-lg-6 d-flex align-items-center pe-lg-5 pe-0 pt-3 pt-lg-0"
          >
            <div>
              <div className="text-2-5  home-contact-text">Get in Touch!</div>
              <div className="pb-1 text-3-2-normal pt-4 home-contact-text">
                To contact us, simply click on the WhatsApp button located at the bottom right of any page on our website and  you can also reach out to us via email.

              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 d-flex justify-content-end align-items-center mt-4">
            <img
              src={callgirlimage}
              alt=""
              style={{
                width: "80%",
                height: "auto",
                maxWidth: "600px",
                objectFit: "cover",
              }}
            />
          </div>
        </div>

        {/* Second Section */}
        <div className="d-flex justify-content-center mt-5 mb-5 padding-5-rem " >
          <div className="row col-12 d-flex justify-content-center">

            {/* 1 */}

            <div className="col-lg-4 col-12 ">
              <div className="bg-light shadow   d-flex  justify-content-center align-items-center p-2 border-15-only border-green-color-contact my-2" >
                <div className="">
                  <div className="d-flex justify-content-center">
                    <div className="bg-green p-2 border-redius-5 my-2 ">
                      <img loading="lazy"
                        src={email}
                        alt="TickShield"
                        height={50}
                        className="w-100"
                      />
                    </div>
                  </div>
                  <div className="text-3-2 text-center ">
                    Chat to support
                  </div>
                  <p className="text-center pt-2">
                    {/* <img src={email} alt="" className="pe-1" height={20} /> */}
                    <a href="https://mail.google.com/mail/?view=cm&fs=1&to=support@anlook.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'none' }}>
                      support@anlook.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
            {/* 2 */}

            <div className="col-lg-4 col-12 ">
              <div className=" bg-light shadow  d-flex justify-content-center align-items-center p-2 border-15-only border-green-color-contact my-2">
                <div className="">
                  <div className="d-flex justify-content-center">
                    <div className="bg-green p-2 border-redius-5 my-2 ">
                      <img loading="lazy" src={address} alt="Chat22" height={50} className="w-100" />
                    </div>
                  </div>
                  <div className="text-3-2 text-center ">
                    Visit us
                  </div>
                  <p className="text-center pt-2 px-2">
                    {/* <img src={address} alt="" className="pe-1" height={20} /> */}
                    {country === "IN" ?
                      <>
                        Ithum Tower, Tower-B, 218, Second Floor,Sector 62 Noida-201309
                      </>

                      :
                      <>
                        3807 S 7TH ST, Phoenix AZ 85040
                      </>

                    }
                  </p>
                </div>
              </div>
            </div>
            {/* 3 */}
            {/* <div className="col-lg-4 col-12 ">
              <div className=" bg-light shadow  d-flex justify-content-center align-items-center p-2 border-15-only border-green-color-contact my-2">
                <div className="">
                  <div className="d-flex justify-content-center">
                    <div className="bg-green p-2 border-redius-5 my-2 ">
                      <img loading="lazy"
                        src={call}
                        alt="CrossChannel"
                        height={50}
                        className="w-100"
                      />
                    </div>
                  </div>
                  <div className="text-3-2 text-center ">
                    Call us
                  </div>
                  <p className="text-center pt-2">
                  
                    {country === "IN" ?
                      <>
                        +91-9958853167
                      </>

                      :
                      <>
                        +1 (732) 310-0621
                      </>

                    }

                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>

        {/* Third Section */}
        <div className='py-5 mb-5 bg-white'>
          <FAQSection />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Contact;
